import { Row, Col, Modal, Button } from 'react-dsgov';
import style from './listaVendaNacionalItem.module.scss';
import { useContext, useState } from 'react';
import { BrButton } from '@govbr-ds/react-components';
import ComponenteNCM from '../../../../../../componenteNCM/componenteNCM';
import { ETipoOperacao } from '../../../../../../../../../../../../enums/ETipoOperacao';
import {
  IVendaNacional,
  IVendaNacionalNCMReceber,
} from '../../../../../../../../../../../../interfaces/IVendaNacional';
import { PaginasOutrosRegimes } from '../../../../../../../../../../../../interfaces/IDadosOutrosRegimes';
import { useBackEndRequests } from '../../../../../../../../../../lib/backEndRequests';
import { useNotificacao } from '../../../../../../../../../../../../hooks/useNotificacao';
import { DiefCfemContext } from '../../../../../../../../../../../../contexts/DiefCfemContext';
import { formatarCNPJOrCpf } from '../../../../../../../../../../../../utils/formatCNPJOrCPF';
import { ETipoRelacionamentoVendaNacional } from '../../../../../../../../../../../../enums/ETipoRelacionamentoVendaNacional';
import CustomConfirmer from '../../../../../../../../../../../../components/customConfirmer/customConfirmer';

export interface IListaVendaNacionalItemProps {
  vendaNacional: IVendaNacional | undefined;
  index: number;

  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  refetchLista: () => void;
  refetchDados: () => void;
}

function ListaVendaNacionalItem({
  vendaNacional,
  index,
  setBaseDeCalculo,
  setIsEdicao,
  refetchLista,
  refetchDados,
}: Readonly<IListaVendaNacionalItemProps>) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);

  const { deleteVendaNacional } = useBackEndRequests();
  const mostrarNotificacao = useNotificacao();
  const context = useContext(DiefCfemContext);

  const editarVendaNacional = () => {
    context?.setIdVendaNacional(vendaNacional?.id ?? -1);
    setIsEdicao(true);
    setBaseDeCalculo('vendaNacional');
  };

  const deletarVendaNacional = async () => {
    await deleteVendaNacional(vendaNacional?.id ?? -1)
      .then(() => {
        refetchLista();
        refetchDados();
        setIsModalOpened(false);
      })
      .catch((err) => {
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao deletar Venda Nacional, tente novamente.',
          ...(err && { complementoSentryId: err }),
        });
      });
  };

  const htmlInfoDadosPessoaRelacionada = () => (
    <div className={style.dadosPessoaRelacionada}>
      <Row>
        <Col md={4} sm={12}>
          <div className={style.label}>Nome</div>
          <p className={style.text}>{vendaNacional?.razaoSocialRelacionado}</p>
        </Col>
        <Col md={4} sm={12}>
          <div className={style.label}>CNPJ</div>
          <p className={style.text}>{formatarCNPJOrCpf(vendaNacional?.cnpjRelacionado || '')}</p>
        </Col>
        <Col md={4} sm={12}>
          <div className={style.label}>Relacionamento</div>
          <p className={style.text}>
            {vendaNacional?.relacionamentoComPJ !== undefined
              ? ETipoRelacionamentoVendaNacional[
                  vendaNacional.relacionamentoComPJ as unknown as keyof typeof ETipoRelacionamentoVendaNacional
                ]
              : ''}
          </p>
        </Col>
      </Row>
    </div>
  );

  const htmlInfoVendaNacional = () => (
    <>
      {htmlInfoDadosPessoaRelacionada()}
      {isAccordionOpen && (
        <ComponenteNCM
          isEdicaoNcm={false}
          isReadOnly={true}
          ncmListaData={vendaNacional?.listaNcm as IVendaNacionalNCMReceber[]}
          type={ETipoOperacao.VENDA_TERRITORIO_NACIONAL_EMPRESAS_COLIGADAS_OU_MESMO_GRUPO_ECONOMICO}
          refetchDadosAnteriores={refetchDados}
          refetchListaNCM={refetchLista}
        />
      )}
    </>
  );

  return (
    <>
      <Modal title='Excluir Venda Nacional selecionada' useScrim modalOpened={isModalOpened}>
        <Modal.Body>Deseja mesmo deletar a Venda Nacional selecionada?</Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => setIsModalOpened(false)}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => deletarVendaNacional()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title}>
            {formatarCNPJOrCpf(vendaNacional?.cnpjRelacionado || '') + ' - ' + vendaNacional?.razaoSocialRelacionado}
          </div>
        </div>
        <div className={style.rightContainer}>
          <BrButton
            data-testid='edit-button'
            circle
            size='small'
            icon='fas fa-edit fa-sm'
            onClick={() => editarVendaNacional()}
          />
          <BrButton
            data-testid='delete-button'
            circle
            size='small'
            icon='fas fa-trash fa-sm'
            onClick={() => setIsModalOpened(true)}
          />
        </div>
      </div>
      {isAccordionOpen && <div className={style.accordionContent}>{htmlInfoVendaNacional()}</div>}
    </>
  );
}

export default ListaVendaNacionalItem;
